export default {
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: String,
        maxlength: {
            type: Number,
            default: 300
        }
    },
    data(){
        return {
            count: this.maxlength
        }
    },
    mounted(){
        this.calcCount()
    },
    watch: {
        maxlength(){
            this.count = this.maxlength
            this.calcCount()
        },
        value(){
            this.$nextTick(() => {
                this.calcCount()
            })
        }
    },
    methods: {
        inputHandle(){
            this.$emit('change', this.$refs.textArea.value)
            this.calcCount()
        },
        calcCount(){
            let dis = this.maxlength - this.$refs.textArea.value.length
            this.count = dis < 0 ? 0 : dis
            if(dis < 0){
                this.$emit('change', this.$refs.textArea.value.slice(0, this.maxlength))
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/CustomTextarea/CustomTextarea.js